/**
 * The experiment flags planning-web reads, keyed by their Optimizely flag key.
 *
 * Values must match the flag key in the Optimizely dashboard exactly and carry the `exp_` prefix —
 * planning-service only surfaces `exp_`-prefixed flags on the `me` payload, so operational flags in
 * the same Optimizely project never reach the frontend (ADR-009).
 *
 * Targeting, rollout percentage, and variant split are dashboard config; shipping a new experiment
 * surface means adding a key here and reading it with `useExperiment`.
 */
enum ExperimentKey {
  /**
   * Streamlined scheduling: the Orders page becomes where unscheduled orders are managed, and the
   * Routes page becomes routes-only.
   *
   * `treatment` lands the organization on Orders rather than Routes (`useWorkspaceLandingPath`) and
   * drops the unscheduled order tray from the Routes page — its view selector offers only Timeline,
   * List, and Map only, and no navigation can land it on the tray
   * (`ui.canViewUnscheduledViews`). The Routes-page quick-add menu also hides its Add orders section
   * so those orgs create orders from the Orders page. `control` keeps today's Routes landing, the
   * full five-view selector, and both quick-add sections.
   */
  OrdersFirstLanding = 'exp_orders_first_landing',
}

export default ExperimentKey;
